import {
    RESERVE_STATUS_ALL,
    RESERVE_STATUS_CANCELLED,
    RESERVE_STATUS_CLOSED,
    RESERVE_STATUS_COMPLETE,
    RESERVE_STATUS_NEW,
    RESERVE_STATUS_OPEN,
    RESERVE_STATUS_PROCESSING,
    ReserveStatusKey
} from './constants';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useStatusSearchParam = (): {
    value: ReserveStatusKey;
    onChange: (newStatus: ReserveStatusKey) => void;
} => {
    const [searchParams, setSearchParams] = useSearchParams();

    const status = searchParams.get('status');

    const onChange = useCallback(
        (newStatus: ReserveStatusKey) => {
            setSearchParams(
                current => {
                    current.set('status', newStatus);
                    return current;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    return useMemo(() => {
        switch (status) {
            case RESERVE_STATUS_NEW:
                return { value: RESERVE_STATUS_NEW, onChange };
            case RESERVE_STATUS_OPEN:
                return { value: RESERVE_STATUS_OPEN, onChange };
            case RESERVE_STATUS_CLOSED:
                return { value: RESERVE_STATUS_CLOSED, onChange };
            case RESERVE_STATUS_PROCESSING:
                return { value: RESERVE_STATUS_PROCESSING, onChange };
            case RESERVE_STATUS_COMPLETE:
                return { value: RESERVE_STATUS_COMPLETE, onChange };
            case RESERVE_STATUS_CANCELLED:
                return { value: RESERVE_STATUS_CANCELLED, onChange };

            default:
                return { value: RESERVE_STATUS_ALL, onChange };
        }
    }, [onChange, status]);
};
